export const strings = {
  en: {
  },
  de: {
  },
};